// extracted by mini-css-extract-plugin
module.exports = {"landing_page_F0":"F0_landing_page_F0__jm1Dr"};